import React, { useState } from 'react';
import { Plus, Search } from 'lucide-react';
import { BackButton } from '../../components/common/BackButton';
import { BlogPostList } from '../../components/admin/blog/BlogPostList';
import { BlogPostForm } from '../../components/admin/blog/BlogPostForm';
import { useBlogPosts } from '../../hooks/admin/useBlogPosts';
import { useAuth } from '../../hooks/auth/useAuth';

export function BlogManagement() {
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [editingPost, setEditingPost] = useState<any>(null);
  const { posts, isLoading, createPost, updatePost, deletePost, refreshPosts } = useBlogPosts();
  const { isAdmin } = useAuth();

  if (!isAdmin) {
    return null;
  }

  const filteredPosts = posts.filter(post =>
    post.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
    post.excerpt.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const handleEditPost = (post: any) => {
    setEditingPost(post);
    setIsFormOpen(true);
  };

  const handleFormClose = () => {
    setIsFormOpen(false);
    setEditingPost(null);
  };


  return (
    <div className="min-h-screen bg-background-dark py-8">
      <div className="max-w-7xl mx-auto px-4">
        <BackButton to="/admin" label="Back to Admin Dashboard" />
        
        <div className="flex justify-between items-center mb-8">
          <h1 className="text-2xl font-bold text-black">Blog Management</h1>
          <button
            onClick={() => setIsFormOpen(true)}
            className="btn-primary flex items-center"
          >
            <Plus className="h-5 w-5 mr-2" />
            Add Post
          </button>
        </div>

        <div className="mb-6">
          <div className="relative">
            <Search className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 h-4 w-4" />
            <input
              type="text"
              placeholder="Search blog posts..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="w-full pl-10 pr-4 py-3 bg-white border border-gray-200 rounded-xl text-black placeholder-gray-400 focus:ring-2 focus:ring-accent-green focus:border-accent-green"
            />
          </div>
        </div>

        <BlogPostList
          posts={filteredPosts}
          isLoading={isLoading}
          onEdit={handleEditPost}
          onDelete={deletePost}
        />

        {isFormOpen && (
          <BlogPostForm
            initialData={editingPost}
            onClose={handleFormClose}
            onSuccess={() => {
              handleFormClose();
              refreshPosts();
            }}
          />
        )}
      </div>
    </div>
  );
}